import { render, staticRenderFns } from "./AgoraCall.vue?vue&type=template&id=4faf839a&scoped=true&"
import script from "./AgoraCall.vue?vue&type=script&lang=js&"
export * from "./AgoraCall.vue?vue&type=script&lang=js&"
import style0 from "./AgoraCall.vue?vue&type=style&index=0&id=4faf839a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faf839a",
  null
  
)

export default component.exports